import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { UserEmailSearchField } from '../UserEmailSearchField';

export const DataOfficerField = ({
  onChange,
  rawErrors,
  required,
  formData,
  schema,
  uiSchema,
}: FieldExtensionComponentProps<string>) => {
  return (
    <UserEmailSearchField
      value={formData}
      onChange={onChange}
      label={schema?.title ?? 'Data Officer'}
      required={required}
      rawErrors={rawErrors}
      helperText={
        (uiSchema?.['ui:help'] as string | undefined) ??
        schema?.description ??
        'Optional. Enter the email of the Data Officer for this request.'
      }
      margin="dense"
    />
  );
};
